import z from '@/lib/zod';
import { TENANT_DETAIL_SECTIONS } from '@/pages/tenants/lib/tenant-detail-sections';

/**
 * La scheda del dettaglio tenant (`?section=`), accettata dalle rotte che
 * aprono il dettaglio sopra una lista (aziende, incaricato). Una scheda
 * sconosciuta scritta a mano diventa «nessuna scheda» (la sheet apre quella
 * di default) invece di far cadere la rotta.
 */
export const tenantDetailSearchSchema = z.object({
  section: z.enum(TENANT_DETAIL_SECTIONS).optional().catch(undefined),
});

export type TenantDetailSearch = z.output<typeof tenantDetailSearchSchema>;
